// Deep link into the AI planner with a destination (and optional trip length) prefilled.
// InnerApp reads ?plan / ?days on load, so this works from standalone routes too.
export function planTripPath(destination, days) {
  const q = new URLSearchParams({ plan: destination });
  if (days) q.set('days', String(days));
  return `/?${q.toString()}`;
}
